/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
// https://github.com/prismicio/prismic-javascript/blob/master/d.ts/documents.d.ts
// https://github.com/prismicio/prismic-javascript/issues/30
// This is a bugfix for the problem that Prismic is mistaking "Document" for the javascript "Document".
// The above issue mentions a fix, but anyway, this is an alternative fix.

import { CmsDocumentTypeMap, CmsDocumentTypes } from "./cms-type-configuration";
import { CmsReportList } from "./types/cms-report";
import { Kind } from "../../components/head/head-models";

export * from "./cms-type-configuration";

export default interface PrismicDocument<
  T = CmsDocumentData,
  Tag = CmsDocumentTypes & keyof CmsDocumentTypeMap,
> {
  id: string;
  uid?: string;
  type: Tag;
  href: string;
  url?: null; // Prismic has started attaching an url parameter to their responses. For us, it is always null.
  tags: string[];
  // slug: string; !!LIES. THIS PROPERTY IS NOT HERE!. Yeah, this is listed in prismic, but it does not actually appear in the api responses.
  slugs: string[];
  lang?: string;
  last_publication_date: string;
  first_publication_date: string;
  // alternateLanguages: string[]; In the api response these are snake_case. Disabling in case this is a bug
  // firstPublicationDate: Date | null;
  // lastPublicationDate: Date | null;
  data: T;
}

export type CmsDocument = CmsDocumentTypeMap[keyof CmsDocumentTypeMap];

export type CmsDevelopPlan = PrismicDocument<CmsDevelopPlanData, CmsDocumentTypes.CmsDevelopPlan>;
export type CmsDevelopPage = PrismicDocument<CmsDevelopPageData, CmsDocumentTypes.CmsDevelopPage>;
export type CmsCarousel = PrismicDocument<CmsCarouselData, CmsDocumentTypes.CmsCarousel>;
export type CmsStrengthItem = PrismicDocument<
  CmsStrengthItemData,
  CmsDocumentTypes.CmsStrengthItem
>;
export type CmsVariable = PrismicDocument<{ name: string }, CmsDocumentTypes.CmsVariable>;
export type CmsSmartSearchPrompts = PrismicDocument<
  { prompts: string },
  CmsDocumentTypes.CmsSmartSearchPrompts
>;

export type SmartJyranian = "Apollo" | "Emile" | "Klara";

export type CmsSmartCallout = PrismicDocument<
  {
    name: string;
    prompt: string;
    example: string;
    jyranian: SmartJyranian;
    manually_triggered: boolean;
  },
  CmsDocumentTypes.CmsSmartCallout
>;
export type CmsSmartTextBox = PrismicDocument<{ height: number }, CmsDocumentTypes.CmsSmartTextBox>;
export type CmsSmartJournalPage = PrismicDocument<
  { name: string; page_title: string },
  CmsDocumentTypes.CmsSmartCallout
>;

export type CmsReportResource = PrismicDocument<
  CmsReportResourceData,
  CmsDocumentTypes.CmsReportPage
>;

export type CmsInfoPage = PrismicDocument<CmsInfoPageData, CmsDocumentTypes.CmsInfoPage>;
export type CmsQuote = PrismicDocument<CmsQuoteData, CmsDocumentTypes.CmsQuote>;
export type CmsResourceThemesPage = PrismicDocument<
  CmsResourceThemesPageData,
  CmsDocumentTypes.CmsResourceThemesPage
>;
export type CmsGoalCapturePage = PrismicDocument<
  CmsGoalCapturePageData,
  CmsDocumentTypes.CmsGoalCapturePage
>;

export type CmsTeamLevel = PrismicDocument<CmsTeamLevelData, CmsDocumentTypes.CmsTeamLevel>;
export type CmsPersonalLevel = PrismicDocument<
  CmsPersonalLevelData,
  CmsDocumentTypes.CmsPersonalLevel
>;
export type CmsTeamMilestone = PrismicDocument<CmsMilestoneData, CmsDocumentTypes.CmsTeamMilestone>;
export type CmsPersonalMilestone = PrismicDocument<
  CmsMilestoneData,
  CmsDocumentTypes.CmsPersonalMilestone
>;

export type CmsTeamLevelsAndMilestones = PrismicDocument<
  CmsTeamLevelsAndMilestonesData,
  CmsDocumentTypes.CmsTeamLevelsAndMilestones
>;

export type CmsPersonalLevelsAndMilestones = PrismicDocument<
  CmsPersonalLevelsAndMilestonesData,
  CmsDocumentTypes.CmsPersonalLevelsAndMilestones
>;

export type CmsWorkshopPage = PrismicDocument<
  CmsWorkshopPageData,
  CmsDocumentTypes.CmsWorkshopPage
>;
export type CmsResourcePlaylist = PrismicDocument<
  CmsResourcePlaylistData,
  CmsDocumentTypes.CmsResourcePlaylist
>;
export type CmsResourceTheme = PrismicDocument<
  CmsResourceThemeData,
  CmsDocumentTypes.CmsResourceTheme
>;
export type CmsSessionWheel = PrismicDocument<
  CmsSessionWheelData,
  CmsDocumentTypes.CmsSessionWheel
>;
export type CmsResource = PrismicDocument<CmsResourceData, CmsDocumentTypes.CmsResource>;
export type CmsLeaderType = PrismicDocument<CmsLeaderTypeData, CmsDocumentTypes.CmsLeaderType>;
export type CmsLinkResource = PrismicDocument<
  CmsLinkResourceData,
  CmsDocumentTypes.CmsLinkResource
>;
export type CmsSession = PrismicDocument<CmsSessionData, CmsDocumentTypes.CmsSession>;
export type CmsSessionWithSlides = PrismicDocument<
  CmsSessionWithSlidesData,
  CmsDocumentTypes.CmsSessionWithSlides
>;
export type CmsCustomStrengthItem = PrismicDocument<
  CmsCustomStrengthItemData,
  CmsDocumentTypes.CmsCustomStrengthItem
>;
export type CmsCustomStrengthMapping = PrismicDocument<
  CmsCustomStrengthMappingData,
  CmsDocumentTypes.CmsCustomStrengthMapping
>;
export type CmsTeamImageList = PrismicDocument<
  CmsTeamImageListData,
  CmsDocumentTypes.CmsTeamImageList
>;

export type CmsPackage = PrismicDocument<CmsPackageData, CmsDocumentTypes.CmsPackage>;

export type CmsSubscriptionPolicy = PrismicDocument<
  CmsSubscriptionPolicyData,
  CmsDocumentTypes.CmsSubscriptionPolicy
>;

export type CmsTeamGoal = PrismicDocument<CmsGoalData, CmsDocumentTypes.CmsTeamGoal>;
export type CmsTeamPathway = PrismicDocument<CmsPathwayData, CmsDocumentTypes.CmsTeamPathway>;
export type CmsTeamPathwayStep = PrismicDocument<
  CmsTeamPathwayStepData,
  CmsDocumentTypes.CmsTeamPathwayStep
>;
export type CmsPersonalGoal = PrismicDocument<CmsGoalData, CmsDocumentTypes.CmsPersonalGoal>;
export type CmsPersonalPathway = PrismicDocument<
  CmsPathwayData,
  CmsDocumentTypes.CmsPersonalPathway
>;
export type CmsPersonalPathwayStep = PrismicDocument<
  CmsPersonalPathwayStepData,
  CmsDocumentTypes.CmsPersonalPathwayStep
>;

export type CmsDigitalPackages = PrismicDocument<
  CmsDigitalPackagesData,
  CmsDocumentTypes.CmsDigitalPackages
>;

export enum CmsCarouselSlideTypes {
  CmsCarouselSlideWithImageAndText = "cms-carousel-slide-with-image-and-text",
}

export interface CmsDocumentData {
  name: string;
  // This is a marker interface
}

export interface CmsRichText {
  pass_this_to_prismic_dom: void;
}

export type CmsKeyText = string | null;

export interface CmsImage {
  type?: "image" | undefined; // Defined if the image is in content, but not if it's an image field
  url: string;
  alt: string | null;
  copyright: string | null;
  edit?: {
    background: string;
    x: number;
    y: number;
    zoom: number;
  };
  dimensions: {
    width: number;
    height: number;
  } | null;
}

export interface CmsLottieFile {
  kind: "document";
  link_type: "Media";
  name: string;
  size: string;
  url: string;
}

export interface CmsSliceBase<SliceTag, TItem, TPrimary> {
  slice_type: SliceTag;
  items: TItem[];
  primary: TPrimary;
  slice_label?: string;
}

export type CmsAudioPlayer = CmsSliceBase<
  "cms-audio-player",
  {},
  {
    clip: CmsMediaLink;
    caption_title: CmsRichText;
    caption_text: CmsRichText;
    is_mandatory: "true" | "false";
  }
>;
export type CmsTextBlock = CmsSliceBase<"cms-text-block", {}, { content: CmsRichText }>;
export type CmsSelfReviewActivity = CmsSliceBase<
  "cms-self-review-activity",
  {},
  {
    caption_title: CmsRichText;
    caption_text: CmsRichText;
    is_mandatory: "true" | "false";
  }
>;
export type CmsHorizontalRule = CmsSliceBase<
  "cms-horizontal-rule",
  {},
  {
    /* TODO */
  }
>;
export type CmsLibraryItemLink = CmsSliceBase<
  "cms-library-item-link",
  {},
  {
    caption_title: CmsRichText;
    caption_text: CmsRichText;
    link: CmsDevelopPageRelationship;
    is_mandatory: "true" | "false";
  }
>;
export type CmsTextExcerpt = CmsSliceBase<
  "cms-text-excerpt",
  {},
  { document: CmsContentRelationship; field_name: string }
>;
export type CmsQuoteEmbed = CmsSliceBase<
  "cms-quote-embed",
  {},
  { document: CmsContentRelationship }
>;
export type CmsTileCarousel = CmsSliceBase<
  "cms-tile-carousel",
  {},
  { tile_carousel_embed_link: CmsResourcePlaylist | CmsResourceTheme }
>;
export type CmsVideoPlayer = CmsSliceBase<"cms-video-player", {}, { media_link: CmsMediaLink }>;
export type CmsCollapsedSection = CmsSliceBase<
  "cms-collapsed-section",
  {},
  {
    text_above: CmsRichText;
    text_below: CmsRichText;
    show_done_button: boolean;
  }
>;
export type CmsSection = CmsSliceBase<"cms-section", {}, { id: string }>;
export type CmsSlice =
  | CmsSection
  | CmsAudioPlayer
  | CmsTextBlock
  | CmsSelfReviewActivity
  | CmsHorizontalRule
  | CmsLibraryItemLink
  | CmsTextExcerpt
  | CmsQuoteEmbed
  | CmsVideoPlayer
  | CmsReportList;

function replaceCharactersInActivityIds(activityId: string) {
  return activityId.replace(/\./g, "-");
}

function sliceToActivityIdFragment(slice: CmsSlice): string {
  if (slice.slice_type === "cms-audio-player") {
    return slice.primary.clip.name || "broken-audio-link";
  }

  if (slice.slice_type === "cms-library-item-link") {
    return slice.primary.link.id || "broken-page-link";
  }

  if (slice.slice_type === "cms-self-review-activity") {
    return "self-review-activity";
  }

  throw new Error("This slice is not an activity");
}

export function isMandatoryActivity(slice: CmsSlice): boolean {
  return "is_mandatory" in slice.primary && slice.primary.is_mandatory === "true";
}

export interface CmsMediaLink {
  link_type: "Media";
  name: string;
  kind: "document" | "image";
  url: string;
  size: string;
  width?: number;
  height?: number;
}

export interface CmsLink {
  url: string;
  target: "_blank" | undefined;
}

export function sliceToActivityId(slice: CmsSlice, cmsPageId: string): string {
  const activityId = sliceToActivityIdFragment(slice);
  return `${cmsPageId}.${replaceCharactersInActivityIds(activityId)}`;
}

// TODO: CmsContentRelationship's data is a partial version of what it points to.
// This can be expressed using Typescript's pick interface and fetchLinks in the cms-remote-store.
// But we're not going to do that yet.
export interface CmsContentRelationship<T = CmsDocumentTypes> {
  id: string;
  type: T;
  tags: string[];
  // slug: string; // is this actually available?
  lang: string;
  uid: string;
  link_type: "Document";
  isBroken: boolean;
}

export interface CmsDevelopPageRelationship
  extends CmsContentRelationship<CmsDocumentTypes.CmsDevelopPage> {
  data?: Partial<CmsDevelopPageData>;
}

export enum CmsQuoteImagePosition {
  none = "none",
  right = "right",
  left = "left",
  bottom = "bottom",
}

export enum CmsQuoteHorizontalBarPosition {
  none = "none",
  top = "top",
  bottom = "bottom",
}

export type DayOrPageType =
  | "library"
  | "journal"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "10"
  | "11"
  | "12"
  | "13"
  | "14"
  | "15"
  | "16"
  | "17"
  | "18"
  | "19"
  | "20"
  | "21"
  | "21"
  | "22"
  | "23"
  | "24"
  | "25";

export interface CmsDevelopPageData extends CmsDocumentData, CmsTileData {
  name: string;
  title: CmsRichText;
  subtitle: CmsRichText;
  title_image: CmsTitleAndTileImage;
  day_or_page_type: DayOrPageType;
  strength_item_id: string;
  body: CmsSlice[];
}

export const globalPlanStructure = [1, 2, 3, 4, 5].map((weekNumber) => ({
  weekNumber,
  cmsTitleMember: `week_${weekNumber}_title` as keyof CmsDevelopPlanWeekTitles,
  days: [1, 2, 3, 4, 5]
    .map((dayInWeek) => (weekNumber - 1) * 5 + dayInWeek)
    .map((day) => ({
      stepRole: `day_${day}`,
      dayNumber: day,
      cmsDayMember: `day_${day}` as keyof CmsDevelopPlanDataPlanStructure,
    })),
}));

export enum CmsStepRoles {
  /* eslint-disable no-unused-vars */
  day_1 = "day_1",
  day_2 = "day_2",
  day_3 = "day_3",
  day_4 = "day_4",
  day_5 = "day_5",
  day_6 = "day_6",
  day_7 = "day_7",
  day_8 = "day_8",
  day_9 = "day_9",
  day_10 = "day_10",
  day_11 = "day_11",
  day_12 = "day_12",
  day_13 = "day_13",
  day_14 = "day_14",
  day_15 = "day_15",
  day_16 = "day_16",
  day_17 = "day_17",
  day_18 = "day_18",
  day_19 = "day_19",
  day_20 = "day_20",
  day_21 = "day_21",
  day_22 = "day_22",
  day_23 = "day_23",
  day_24 = "day_24",
  day_25 = "day_25",
}

export type CmsDevelopPlanDataPlanStructure = {
  [x in keyof typeof CmsStepRoles]: CmsDevelopPageRelationship;
};

export interface CmsDevelopPlanWeekTitles {
  week_1_title: CmsRichText;
  week_2_title: CmsRichText;
  week_3_title: CmsRichText;
  week_4_title: CmsRichText;
  week_5_title: CmsRichText;
}

export interface CmsDevelopPlanData
  extends CmsDocumentData,
    CmsDevelopPlanDataPlanStructure,
    CmsDevelopPlanWeekTitles {
  name: string;
  title: CmsRichText;
  strength_item_id: string;
  library: CmsDevelopPageRelationship | null;
}

export interface CmsDevelopLibraryData {
  name: string;
  title: CmsRichText;
  items: { page: CmsDevelopPageRelationship }[];
}

export interface CmsCarouselData extends CmsDocumentData {
  name: string;
  body: CmsSlice[];
}

export interface CmsStrengthItemData extends CmsDocumentData {
  name: string;
  title: CmsRichText;
  strength_item_id: string;
  strength_image: CmsImage;
  positive_indicators: { description: CmsRichText }[];
  negative_indicators: { description: CmsRichText }[];
  short_definition: CmsRichText;
  long_description: CmsRichText;
  questions: { wording: CmsRichText; scoring: "positive" | "negative" }[];
}

export interface CmsCustomStrengthItemData extends CmsDocumentData {
  name: string;
  title: CmsRichText;
  draggable_name: string;

  positive_indicators: { description: CmsRichText }[];
  negative_indicators: { description: CmsRichText }[];
  short_definition: CmsRichText;
}

export interface CmsCustomStrengthMappingData extends CmsDocumentData {
  title: CmsRichText;
  viewpoints_respondent_question: CmsRichText;
  interstitial_full_size_image: CmsImage;
  report_title: CmsRichText;
  report_subtitle: CmsRichText;
  page_visual_theme: string;
  pages: {
    item_1_embed_link: CmsCustomStrengthItem;
    item_2_embed_link: CmsCustomStrengthItem;
    item_3_embed_link: CmsCustomStrengthItem;
    item_4_embed_link: CmsCustomStrengthItem;
    item_5_embed_link: CmsCustomStrengthItem;
    item_6_embed_link: CmsCustomStrengthItem;
    item_7_embed_link: CmsCustomStrengthItem;
    item_8_embed_link: CmsCustomStrengthItem;
    item_9_embed_link: CmsCustomStrengthItem;
    item_10_embed_link: CmsCustomStrengthItem;
    page_header: CmsRichText;
  }[];
  body: CmsSlice[];
}

export interface CmsInfoPageData extends CmsDocumentData {
  name: string;
  content: CmsRichText;
}

export interface CmsQuoteData extends CmsDocumentData {
  name: string;
  content: CmsRichText;
  source: CmsRichText;
  image_position: CmsQuoteImagePosition;
  image: CmsMediaLink;
  horizontal_bar_position: CmsQuoteHorizontalBarPosition;
}

export interface CmsTitleAndTileImage extends CmsImage {
  tile: CmsImage;
}

export interface CmsTileData {
  title_image: CmsTitleAndTileImage;
  tile_title: CmsRichText;
}

export interface CmsResourceThemesPageTileItemData {
  theme_title_image: CmsImage;
  theme_tile_title: string;
}

export interface CmsResourceThemesPageItemRelationship extends CmsContentRelationship {
  data?: Partial<CmsResourceThemesPageTileItemData>;
}

export interface CmsResourceRelationship extends CmsContentRelationship {
  data?: Partial<CmsResourceData>;
}

export interface CmsPlaylistRelationship extends CmsContentRelationship {
  data?: Partial<CmsResourcePlaylistData>;
}

export interface CmsPathwaysRelationship extends CmsContentRelationship {
  data?: Partial<CmsPathwayData>;
  pathway: {
    id: string;
    uid: string;
    data: CmsPathwayData;
  };
}

export interface CmsGoalRelationship extends CmsContentRelationship {
  data?: Partial<CmsGoalData>;
}

export interface CmsPackagesRelationship extends CmsContentRelationship {
  package: { data?: Partial<CmsPackageData>; uid: string };
}

export interface CmsResourceThemesPageData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
  body: CmsTileCarousel[];
  items: { link: CmsResourceRelationship }[];
}

export interface CmsWorkshopPageData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
  side_nav_icon: CmsImage;
  prep: CmsResourceRelationship;
  description: CmsRichText;
  workshop: CmsResourceRelationship;
  resources: CmsResourcePlaylist | CmsResourceTheme;
}

export type TeamMemberAction =
  | "none"
  | "team pathway step"
  | "personal pathway step"
  | "view resource";

export interface CmsPersonalLevelData extends CmsDocumentData {
  title: CmsRichText;
  level_type: "session" | "viewpoint-invite-modal";
  level_number: number;
  description: CmsRichText;
  uplifts_list: { uplift: CmsRichText }[];
  practicalities_list: { practicality: CmsRichText }[];
  go_button_text: CmsRichText;
  resource_link?: CmsLink;
  action_resource_link?: CmsLinkResource;
  pathway_type: "personal";
  pathway_to_initiate?: CmsPathwaysRelationship;
}

export interface CmsTeamLevelData extends CmsDocumentData {
  title: CmsRichText;
  level_type: "session" | "team-invite-modal";
  requires_team_action: TeamMemberAction;
  level_number: number;
  description: CmsRichText;
  uplifts_list: { uplift: CmsRichText }[];
  practicalities_list: { practicality: CmsRichText }[];
  go_button_text: CmsRichText;
  resource_link?: CmsLink;
  action_resource_link?: CmsLinkResource;
  initiate_pathway: boolean;
  pathway_type: "team" | "personal";
  pathway_to_initiate?: CmsPathwaysRelationship;
}

export interface CmsMilestoneData extends CmsDocumentData {
  title: CmsRichText;
  milestone_number: number;
}

export interface CmsLevelsRelationship extends CmsContentRelationship<CmsTeamLevel> {
  data: CmsTeamLevelData;
}

export interface CmsMilestonesRelationship extends CmsContentRelationship<CmsTeamMilestone> {
  data: CmsMilestoneData;
}

export type CmsTeamLevelsAndMilestonesListItem = {
  level_or_milestone: CmsLevelsRelationship | CmsMilestonesRelationship;
  in_testing: boolean;
};

export interface CmsPersonalLevelsRelationship extends CmsContentRelationship<CmsPersonalLevel> {
  data: CmsPersonalLevelData;
}

export type CmsPersonalLevelsAndMilestonesListItem = {
  level_or_milestone: CmsPersonalLevelsRelationship | CmsMilestonesRelationship;
  in_testing: boolean;
};

export interface CmsTeamLevelsAndMilestonesData extends CmsDocumentData {
  title: CmsRichText;
  team_levels_and_milestones_list: CmsTeamLevelsAndMilestonesListItem[];
}

export interface CmsPersonalLevelsAndMilestonesData extends CmsDocumentData {
  title: CmsRichText;
  personal_levels_and_milestones_list: CmsPersonalLevelsAndMilestonesListItem[];
}

export interface CmsGoalCapturePageData extends CmsDocumentData {
  analyses: CmsGoalAnalysis[];
  introduction: CmsRichText;
  suggestion_prompt: CmsSmartCallout;
  title: CmsRichText;
}

export interface CmsGoalAnalysis {
  type: string;
  smart_callout: CmsSmartCallout;
}

export interface CmsResourcePlaylistData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
  description: CmsRichText;
  overview_button_link: CmsResourceRelationship;
  overview_button_title: CmsRichText;
  side_nav_icon: CmsImage;
  items: { link: CmsResourceRelationship }[];
  page_visual_theme: string;
}

export interface CmsSessionWheelData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
  side_nav_icon: CmsImage;
  description: CmsRichText;
  items: {
    link: CmsDocument;
    item_button_text: CmsRichText;
    item_type_text: CmsRichText;
  }[];
  page_visual_theme: string;
  item_default_button_text: CmsRichText;
  item_default_type_text: CmsRichText;
}

export interface CmsResourceThemeData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
  side_nav_icon: CmsImage;
  items: { link: CmsPlaylistRelationship }[];
  page_visual_theme: string;
}

export interface CmsResourceData extends CmsDocumentData, CmsTileData {
  name: string;
  title: CmsRichText;
  subtitle: CmsRichText;
  title_image: CmsTitleAndTileImage;
  title_image_animation: CmsMediaLink;
  tile_image_animation: CmsMediaLink;
  page_visual_theme: string; // Ending in -theme
  title_layout: string;
  day_or_page_type: "library" | "journal";
  body: CmsSlice[];
}

export interface CmsPackageData {
  title: CmsRichText;
  subtitle: CmsRichText;
  free_trial_period: number;
  price: number;
  price_description: CmsRichText;
  annual_price: number;
  annual_price_description;
  icon: CmsImage;
  description: { text: CmsRichText }[];
}

export interface CmsDigitalPackagesData {
  title: CmsRichText;
  packages: CmsPackagesRelationship[];
}

export interface CmsSubscriptionPolicyData {
  title: CmsRichText;
  policy: CmsRichText;
}

export interface CmsGoalData {
  full_title: CmsRichText;
  name: CmsRichText;
  goal_colour?: string;
  brief_description?: CmsRichText;
  journey: string;
  image: CmsImage;
  pathways: CmsPathwaysRelationship[];
}

export interface CmsPathwayData {
  title: CmsRichText;
  short_description: string;
  description: CmsRichText;
  benefits: { benefit_description: CmsRichText }[];
  practicalities: { practicality_title: CmsRichText; practicality_description: CmsRichText }[];
  goal_relationship: CmsGoalRelationship;
  title_image: CmsTitleAndTileImage;
  pathway_steps: {
    step_description: CmsRichText;
    step_type_text: CmsKeyText;
    step_button_text: CmsKeyText;
    pathway_step: CmsContentRelationship<CmsTeamPathwayStep>;
  }[];
  pathway_complete_content: CmsRichText;
}

export interface CmsReportResourceData extends CmsDocumentData {
  title: CmsRichText;
  report_type: "Solo" | "Team Solo" | "Viewpoints" | "Team Viewpoints";
}

export interface CmsLeaderTypeData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
}

export interface CmsLinkResourceData extends CmsTileData {
  title: CmsRichText;
  link: CmsLink;
  link_url: CmsKeyText;
  search_type_name: CmsKeyText;
}

export interface CmsSessionData extends CmsDocumentData, CmsTileData {
  title: CmsRichText;
}

export type CmsControlSlide = {
  slice_type: "cms-control-slide";
  primary: {
    text_body: CmsRichText;
    control: CmsResourceRelationship;
  };
  items: void[];
};

export type CmsSessionSlideWithText = {
  slice_type: "cms-session-slide-text";
  primary: {
    text_body: CmsRichText;
  };
  items: void[];
};

export type CmsSessionSlideWithTextAndImage = {
  slice_type: "cms-session-slide-text-and-image";
  primary: {
    text_body: CmsRichText;
    image: CmsImage;
  };
  items: void[];
};

export type CmsSessionSlideWithTextAndLottie = {
  slice_type: "cms-session-slide-text-and-lottie";
  primary: {
    text_body: CmsRichText;
    lottie_file: CmsLottieFile;
    fade_out_transition: boolean;
  };
  items: void[];
};

export type CmsSessionSlideWithButtonTextAndLottie = {
  slice_type: "cms-session-slide-with-button-and-lottie";
  primary: {
    text_body: CmsRichText;
    lottie_file: CmsLottieFile;
    fade_out_transition: boolean;
    button_text: CmsRichText;
    button_link: CmsLink | CmsMediaLink | CmsResourceRelationship;
  };
  items: void[];
};

export type CmsSessionSlideWithCompleteButtonTextAndLottie = {
  slice_type: "cms-session-slide-with-complete-button-and-lottie";
  primary: {
    text_body: CmsRichText;
    lottie_file: CmsLottieFile;
    fade_out_transition: boolean;
    button_text: CmsRichText;
    button_link: CmsLink | CmsMediaLink | CmsResourceRelationship;
    display_close_button: boolean;
  };
};

export type CmsSessionSlideWithFullScreenLottie = {
  slice_type: "cms-session-slide-fullscreen-lottie";
  primary: {
    lottie_file: CmsLottieFile;
    fade_out_transition: boolean;
  };
  items: void[];
};

export type CmsSessionSlideWithButton = {
  slice_type: "cms-session-slide-with-button" | "cms-session-slide-with-complete-button";
  primary: {
    text_body: CmsRichText;
    image: CmsImage;
    button_text: CmsRichText;
    button_link: CmsLink | CmsMediaLink | CmsResourceRelationship;
    display_close_button: boolean;
  };
  items: void[];
};

export type CmsSessionSlideWithChecklist = {
  slice_type: "cms-session-slide-with-checklist";
  primary: {
    text_body: CmsRichText;
    image: CmsImage;
    max_choices: number;
    checklist_id: CmsRichText;
    checklist_shuffle: boolean;
  };
  items: {
    checklist_answer_label: CmsRichText;
    checklist_answer_id: CmsRichText;
  }[];
};

export type CmsSessionSlideWithDropdown = {
  slice_type: "cms-session-slide-with-dropdown";
  primary: {
    text_body: CmsRichText;
    image: CmsImage;
    dropdown_id: CmsRichText;
    dropdown_shuffle: boolean;
  };
  items: {
    dropdown_answer_label: CmsRichText;
    dropdown_answer_id: CmsRichText;
  }[];
};

export type DataCaptureSlideType = "pre-strength-mapping" | "post-strength-mapping";

export type CmsSessionSlideWithDataCapture = {
  slice_type: "cms-session-slide-with-data-capture";
  primary: {
    type: DataCaptureSlideType;
    image: CmsImage;
  };
  items: void[];
};

export type QuestionnaireType = "strengths" | "indicators";

export type CmsStrengthMapping = {
  slice_type: "cms-strength-mapping";
  primary: {
    questionnaire_type: QuestionnaireType;
  };
  items: void[];
};

export type CmsSessionSlideWithTextAndHead = {
  slice_type: "cms-session-slide-text-and-solo-head" | "cms-session-slide-text-and-head";
  primary: {
    text_body: CmsRichText;
    head_type: Kind;
  };
  items: void[];
};

export type SessionType = "default" | "level";

export interface CmsSessionWithSlidesData extends CmsDocumentData, CmsTileData {
  close_button_goes_to: "home" | "team" | "based-on-final-slide" | "log-off";
  body: (
    | CmsSessionSlideWithChecklist
    | CmsSessionSlideWithDropdown
    | CmsSessionSlideWithButton
    | CmsSessionSlideWithTextAndImage
    | CmsSessionSlideWithText
    | CmsControlSlide
    | CmsSessionSlideWithTextAndLottie
    | CmsSessionSlideWithButtonTextAndLottie
    | CmsSessionSlideWithFullScreenLottie
    | CmsStrengthMapping
    | CmsSessionSlideWithTextAndHead
    | CmsSessionSlideWithDataCapture
    | CmsPathwayStepFinalSlide
    | CmsSessionSlideWithCompleteButtonTextAndLottie
  )[];
  title: CmsRichText;
  session_type: SessionType;
  background_image: CmsImage;
  logo_image: CmsImage;
}

export interface CmsTeamPathwayStepData extends CmsSessionWithSlidesData {
  final_slide_text: CmsRichText;
  final_slide_image: CmsImage;
  final_slide_lottie_file: CmsLottieFile;
  complete_button_text: CmsKeyText;
}

export type CmsPersonalPathwayStepData = Omit<CmsTeamPathwayStepData, "close_button_goes_to">;

export interface CmsPathwayStepFinalSlide {
  slice_type: "cms-final-pathway-step-slice";
  primary: {
    text: CmsRichText;
    textHtml: string;
    image: CmsImage;
    lottieFile: CmsLottieFile;
    lottieShouldFadeOut: false;
    buttonText: string;
    // leaving this undefined means that it is up to the button to decide on the link
    buttonLink: undefined;
    isCompleteButton: true;
  };
  items: void[];
}

export interface CmsTeamImageListData extends CmsDocumentData {
  list: { image: CmsImage }[];
}

export type PrismicSlice =
  | CmsSessionSlideWithChecklist
  | CmsSessionSlideWithDropdown
  | CmsSessionSlideWithButton
  | CmsSessionSlideWithTextAndImage
  | CmsControlSlide
  | CmsSessionSlideWithTextAndLottie
  | CmsSessionSlideWithButtonTextAndLottie
  | CmsSessionSlideWithFullScreenLottie
  | CmsStrengthMapping
  | CmsSessionSlideWithTextAndHead
  | CmsPathwayStepFinalSlide
  | CmsSessionSlideWithText
  | CmsSessionSlideWithDataCapture
  | CmsSessionSlideWithCompleteButtonTextAndLottie;

// The kitchen sink page is used for testing and download verification purposes.
export const kitchenSinkPageId = "WrLPuCgAAClcoEk9";
export const kitchenSinkPageUid = "kitchen-sink-page";

export * from "./types/cms-team-effectiveness-review";
